module.exports = __webpack_public_path__ + "static/media/instructions-right.7af2f228.png";